import { useContext, useState } from "react"
import { ReactComponent as Logo } from "../../assets/images/starting-finance-minimized.svg"
import style from "./Footer.module.css"
import Dialog from "../dialogs/Dialog"
import MainContext from "../../common/MainContext"

const Footer = () => {
    const context = useContext(MainContext)
    const [contactsOpen, setContactsOpen] = useState(false)

    return (
        <footer className={style.container}>
            <div className={style.inner}>
                <div className={style.info}>
                    <Logo className={style.logo} aria-hidden="true" />
                    <div className={style.company}>
                        <span className={style.copyright}>© {new Date().getFullYear()} Starting Finance SRL</span>
                        <span className={style.vatNumber}>Partita IVA: 14944641001</span>
                    </div>
                </div>
                <nav className={style.links} aria-label="Informazioni e assistenza">
                    <button type="button" onClick={() => setContactsOpen(true)}>Contatti</button>
                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy e cookie</a>
                    <button type="button" onClick={() => window.Cookiebot?.renew()}>Impostazioni cookie</button>
                    <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Condizioni d’uso</a>
                </nav>
                {context.appVersion && <span className={style.appVersion}>Versione {context.appVersion}</span>}
            </div>
            <Dialog appearance="modern" open={contactsOpen} title="Contatti" onClose={() => setContactsOpen(false)} style={{ width: '100%', maxWidth: 520 }}>
                <div className={style.contacts}>
                    <p className={style.contactsIntro}>Scrivici all’indirizzo dedicato al tipo di assistenza di cui hai bisogno.</p>
                    <section className={style.contactItem}>
                        <h3>Supporto tecnico</h3>
                        <p>Per problemi di accesso o di funzionamento della piattaforma.</p>
                        <a href="mailto:support@startingfinance.com">support@startingfinance.com</a>
                    </section>
                    <section className={style.contactItem}>
                        <h3>Didattica e informazioni</h3>
                        <p>Per informazioni sui percorsi e assistenza con corsi, lezioni e attività didattiche.</p>
                        <a href="mailto:education@startingfinance.com">education@startingfinance.com</a>
                    </section>
                </div>
            </Dialog>
        </footer>
    )
}

export default Footer
